import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ConfirmationDialog, ConfirmationDialogDefinition} from '@aviary/dialogs/confirmation-dialog/confirmation-dialog.types';
import {ConfirmationDialogComponent} from '@aviary/dialogs/confirmation-dialog/confirmation-dialog.component';
import {Checkout} from '@store/checkouts/checkouts.types';
import {CheckoutDetailComponent} from '@app/my-account/checked-out/detail/checkout-detail.component';
import {isPositiveNumber} from '@aviary/store/common/typing.helpers';

export interface RenewAllDialogData {
  firstCheckout: Checkout;
  additionalItemCount: number;
}

@Component({
  selector: 'px-renew-all-dialog',
  template: `
    <mx-confirmation-dialog [definition]="dialogDefinition">
      <px-checkout-detail [checkout]="checkout"/>
    </mx-confirmation-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ConfirmationDialogComponent, CheckoutDetailComponent]
})
export class RenewAllDialog implements ConfirmationDialog<RenewAllDialogData> {
  public readonly dialogData: RenewAllDialogData = inject(MAT_DIALOG_DATA);
  public readonly checkout = this.dialogData.firstCheckout;
  public readonly additionalItemCount = this.dialogData.additionalItemCount;

  public readonly dialogDefinition: ConfirmationDialogDefinition = {
    title: 'Renew All Items',
    description: 'Some items may not be eligible for renewal due to existing holds from other patrons or if the maximum number of renewals has been reached.',
    prompt: isPositiveNumber(this.additionalItemCount) ? `and ${this.additionalItemCount} additional item${this.additionalItemCount === 1 ? '' : 's'}...` : '',
    confirmButtonLabel: 'Renew All'
  };
}
